module.exports = __webpack_public_path__ + "img/worldcup_main.42766a73.png";